"use client";
import { useState } from "react";
import Link from "next/link";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    await fetch("/api/auth/request-reset", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });
    setLoading(false);
    setMessage("If an account exists, a reset link has been sent.");
  }

  return (
    <div style={{ display: "grid", placeItems: "center", minHeight: "70vh" }}>
      <form className="card" onSubmit={submit} style={{ width: 360, display: "grid", gap: 12 }}>
        <h3 style={{ margin: 0 }}>Reset password</h3>
        <input
          className="input"
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        {message ? <div style={{ fontSize: 13, color: "var(--color-text-muted)" }}>{message}</div> : null}
        <button className="btn" disabled={loading}>{loading ? "Sending…" : "Send reset link"}</button>
        <div style={{ fontSize: 12, textAlign: "center" }}>
          <Link href="/login">Back to sign in</Link>
        </div>
      </form>
    </div>
  );
}

